import { language } from '@tencent/wphk-utils';
import type {
  LanguageMap,
  InterpolationData
} from './types';

/**
 * 创建完全隔离的 i18n 实例
 * @param config 初始语言配置（可选）
 * @returns 独立的 i18n 实例
 */
export function createI18n(config?: LanguageMap) {
  // 每个实例有自己独立的配置
  let instanceLangMap: LanguageMap = config ? { ...config } : {};

  const instanceI18n = (key: string, data?: InterpolationData): string => {
    const lang = language.getLanguage();
    const langConfig = instanceLangMap[lang] || {};
    const value = langConfig[key];

    if (typeof value !== 'string' || !value) {
      return key;
    }

    return data ? value.replace(/{{([^}]+)}}/g, (_, k) => k in data ? String(data[k]) : `{{${k}}}`) : value;
  };

  return {
    /**
     * 初始化或更新配置
     */
    init: (config: LanguageMap) => {
      if (!config || Object.keys(config).length === 0) {
        throw new Error('Language configuration is required.');
      }

      if (!Object.keys(instanceLangMap).length) {
        instanceLangMap = { ...config };
      } else {
        for (const lang in config) {
          if (config[lang]) {
            instanceLangMap[lang] = { ...(instanceLangMap[lang] || {}), ...config[lang] };
          }
        }
      }
    },

    /**
     * 翻译函数
     */
    i18n: instanceI18n,

    /**
     * 获取当前实例的配置
     */
    getConfig: (): LanguageMap => ({ ...instanceLangMap }),

    /**
     * 重置配置
     */
    reset: () => {
      instanceLangMap = {};
    },
  };
}
